export default __webpack_public_path__ + "static/media/sitka-small-652.370a5f62.ttf";